export const ON_LOAD_NOTIFICATIONS = "ON_LOAD_NOTIFICATIONS";
